export default __webpack_public_path__ + "static/media/signup-illustration.2876a99f.svg";